import { Optional, withDefault } from '@vy/utils';
import { useLocation } from 'react-router-dom';
import {
  AssignCustomerForm,
  AssignCustomerFormSchema,
} from '../../GetStartedPlansPage/types/assign-customer-dialog-form-types/assign-customer-form-schema';

export const useGetContractPrerequisites = (): Optional<AssignCustomerForm> => {
  const location = useLocation();
  const navigationState = withDefault<AssignCustomerForm | null>(location.state, null);
  const parsedNavigationState = AssignCustomerFormSchema.safeParse(navigationState);

  return parsedNavigationState.data;
};
